import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StyledMarkdown } from "components/shared/styled-markdown/styled-markdown";

interface DataDictionaryProps {
  dataDictionaries?: { [key: string]: string };
}

export const CatalogueEntryDataDictionary = ({
  dataDictionaries,
}: DataDictionaryProps) => {
  if (!dataDictionaries) {
    return null;
  }

  const sortedKeys = Object.keys(dataDictionaries).sort();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Data Dictionary</CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue={sortedKeys[0]} className="w-full">
          <TabsList className="w-full justify-start gap-1 overflow-x-auto">
            {sortedKeys.map((key) => (
              <TabsTrigger key={key} value={key}>
                {key}
              </TabsTrigger>
            ))}
          </TabsList>
          {sortedKeys.map((key) => (
            <TabsContent key={key} value={key} className="pt-4">
              <div className="max-w-none">
                <StyledMarkdown>{dataDictionaries[key]}</StyledMarkdown>
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </CardContent>
    </Card>
  );
};
